import React from "react";
import { Heart } from "lucide-react";

const ProductCard = ({ product, navigateTo, favorites = [] }) => {
  // Najde obrázek, ať už je v datech jako 'image' nebo 'images'
  const imageUrl = product.image || (product.images && product.images[0]);
  
  // Kontrola, zda je tento konkrétní produkt v oblíbených
  const isFavorite = favorites.includes(product.id);

  return (
    <div
      onClick={() => navigateTo("productDetail", product.id)}
      /* UPRAVENO: Větší zaoblení (2xl), plynulejší stín a zvednutí při najetí myší */
      className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm hover:shadow-xl hover:shadow-slate-200/60 hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col text-left w-full sm:w-[calc(50%-1.5rem)] md:w-[calc(33.333%-1.5rem)] lg:w-[calc(25%-1.5rem)] max-w-sm group relative"
    >
      {/* OBLÍBENÉ SRDÍČKO - JEN VIZUÁLNÍ (Bez klikání) */}
      {isFavorite && (
        <div
          className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/80 backdrop-blur-sm shadow-sm border border-red-100 pointer-events-none"
          title="Máte v oblíbených"
        >
          <Heart className="w-5 h-5 text-red-500 fill-red-500" />
        </div>
      )}

      <div className="h-48 bg-slate-50 flex items-center justify-center p-4">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={product.name}
            className="max-h-full object-contain mix-blend-multiply transition duration-500 group-hover:scale-105"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : (
          <div className="text-slate-400 text-sm font-medium">Bez obrázku</div>
        )}
      </div>

      <div className="p-5 flex flex-col flex-grow">
        {/* UPRAVENO: Trošku větší a tmavší text nadpisu pro lepší čitelnost */}
        <h3 className="font-bold text-[15px] text-slate-800 mb-2 line-clamp-2">
          {product.name}
        </h3>
        {/* UPRAVENO: Větší cena, aby to byl první údaj, co zákazník vidí */}
        <div className="font-extrabold text-xl text-green-600 mb-5">
          {product.price === 0
            ? "0 Kč"
            : `${product.price.toLocaleString()} Kč`}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigateTo("productDetail", product.id);
          }}
          /* UPRAVENO: Zelené tlačítko s barevným glow stínem, oblými rohy a animací */
          className="w-full py-3 bg-green-600 text-white text-sm font-bold text-center rounded-xl shadow-md shadow-green-600/20 hover:bg-green-500 hover:shadow-lg hover:shadow-green-600/40 hover:-translate-y-0.5 transition-all duration-300 mt-auto pointer-events-auto"
        >
          Zjistit více
        </button>
      </div>
    </div>
  );
};

export default ProductCard;